import React, { Component } from 'react';
import { useRefJs } from '@platform/api';
useRefJs.setConfig({ 'business_component/billTrack/billTrack/main/index': '../../../../platform/resource/business_component/billTrack/billTrack/main/index.js' });

let BillTrack = useRefJs(["business_component/billTrack/billTrack/main/index"], function (Poc) {
    class BillTrack extends Component {
        constructor(props) {
            super(props);
        }
        render() {
            const { forwardedRef, ...rest } = this.props;
            return <Poc ref={forwardedRef} {...rest} />
        }
    }
    return React.forwardRef((props, ref) => {  
        return <BillTrack {...props} forwardedRef={ref} />;  
    });
});

export default BillTrack;
